
/**
 * @returns {Function} разбиение по маске 1123456 => 1 123 456 р. || '' => '-'
 *
 * @param {Number} str - строка
 */
export default (input) => {
    const str = String(input);
    if (str && str.length) {
        return str.replace(/(\d)(?=(\d{3})+(\D|$))/g, '$1 ') + ' р.';
    } else {
        return '—';
    }
};
